import { useClientLimitedEvents } from '@ukpostbox/client-data';
import {
	Button,
	ColourStateSolid,
	ContentBlock,
	ContentLoader,
	FlexGap,
	StackVertical,
	useTranslation,
} from '@ukpostbox/frontend-framework';
import React from 'react';
import { useNavigate } from 'react-router';
import { useSite } from '../Providers/SiteInterfaceProvider';

function GetInTouch() {
	const navigate = useNavigate();
	const { UpdateSiteContact } = useSite();
	const { t } = useTranslation();
	const { status, error } = useClientLimitedEvents();

	return status === 'pending' ? (
		<ContentLoader round childHeight='15em' childCount={1} />
	) : status === 'error' ? (
		<ContentBlock error title={error.name} content={error.message} />
	) : (
		<ContentBlock
			stacked
			showBorder
			title={t('getInTouch.title')}
			content={t('getInTouch.description')}
			media={
				<div className='square-img mb-md'>
					<img src={`${process.env.PUBLIC_URL}/images/get-in-touch.svg`} alt={t('getInTouch.imageAlt')} />
				</div>
			}
			extraClass='text-center'
			addon={
				<StackVertical gap={FlexGap.Small}>
					<Button
						squared
						title={t('getInTouch.actions.message')}
						onClick={() => UpdateSiteContact(true)}
						colour={ColourStateSolid.Primary}
					/>
					<Button
						squared
						title={t('getInTouch.actions.call')}
						onClick={() => navigate('https://www.ukpostbox.com/contact/callback-request')}
					/>
				</StackVertical>
			}
		/>
	);
}

export default GetInTouch;
